export default "__VITE_ASSET__BXwOYU1a__"